module.exports = __webpack_public_path__ + "img/png.67ff493a.png";